import { SearchOutlined } from '@ant-design/icons';
import { Button, Row, Col } from 'antd';
import { resetSearchValue } from 'pages/ListMedicalInstitution/slice';
import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Redirect } from 'react-router-dom';
import { BackToListMedical, HeaderTitle, Rectangle } from 'components';
import { RootState } from '../../../store';
import Wrap from './styles';

const MedicalInstitutionDetail: FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { data } = useSelector((state: RootState) => state.medicalDetail);

  useEffect(() => {
    return () => {
      if (history.location.pathname !== '/medical_institution') {
        dispatch(resetSearchValue());
      }
    };
  }, [history.location.pathname, dispatch]);

  const listMedical = () => {
    history.push('/medical_institution');
  };
  const editMedical = () => {
    history.push('/medical_institution/edit');
  };
  if (!data) {
    return <Redirect to="/medical_institution" />;
  }
  return (
    <Wrap>
      <HeaderTitle title="医療機関一覧・検索" icon={SearchOutlined} />
      <BackToListMedical backToPrev={listMedical} />
      <div className="detail-medical">
        <span className="extraLargeFont">医療機関詳細</span>
        <Button onClick={() => editMedical()} className="btn-edit standardBoldFont">
          編集する
        </Button>
      </div>
      <div className="section">
        <div className="detail">
          <div style={{ borderBottom: '1px solid #dddddd' }}>
            <Rectangle text="医療機関" />
          </div>
          <div className="info">
            <Row className="mb-15">
              <Col className="smallBoldFont" span={5}>
                お取引先番号
              </Col>
              <Col className="standardFont" span={19}>
                {data?.facility_code}
              </Col>
            </Row>
            <Row className="mb-15 not-border-bottom">
              <Col className="smallBoldFont" span={5}>
                医療機関名
              </Col>
              <Col className="standardFont" span={19}>
                {data?.facility_name}
              </Col>
            </Row>
            <Row className="mb-15 flex-align">
              <Col span={5} />
              <Col className="standardFont" span={19}>
                <Row className="mb-10 label">請求書出力用 請求書出力用 改行位置設定</Row>
                <Row className="mb-10 textarea">{data?.facility_name_for_invoice}</Row>
              </Col>
            </Row>
            <Row className="mb-15 flex-align not-border-bottom">
              <Col className="smallBoldFont" span={5}>
                所在地
              </Col>
              <Col className="standardFont" span={19}>
                <Row className="mb-10">〒{data?.facility_zip}</Row>
                <Row>
                  {data?.facility_address1}
                  {data?.facility_address2}
                </Row>
              </Col>
            </Row>
            <Row className="mb-15 flex-align">
              <Col span={5} />
              <Col className="standardFont" span={19}>
                <Row className="mb-10 label">
                  請求書出力用 改行位置設定 （都道府県/市区町村/番地 マンション・ビル・建物）
                </Row>
                <Row className="mb-10 textarea">{data?.facility_address_for_invoice}</Row>
              </Col>
            </Row>
            <Row className="mb-15">
              <Col className="smallBoldFont" span={5}>
                電話番号
              </Col>
              <Col className="standardFont" span={19}>
                {data?.facility_tel}
              </Col>
            </Row>
            <Row className="mb-15">
              <Col className="smallBoldFont" span={5}>
                支払方法
              </Col>
              <Col className="standardFont" span={19}>
                {data?.payment_method}
              </Col>
            </Row>
            <Row className="mb-15">
              <Col className="smallBoldFont" span={5}>
                CPAP単価
              </Col>
              <Col className="standardFont" span={19}>
                {`￥ ${
                  data?.cpap_unit_price || data?.cpap_unit_price === 0
                    ? parseInt(data.cpap_unit_price.toString()).toLocaleString()
                    : ''
                }`}
              </Col>
            </Row>
            <Row className="mb-15">
              <Col className="smallBoldFont" span={5}>
                CPAP単価特別料金
              </Col>
              <Col className="standardFont" span={19}>
                {`￥ ${
                  data?.cpap_unit_sp_price || data?.cpap_unit_sp_price === 0
                    ? parseInt(data.cpap_unit_sp_price.toString()).toLocaleString()
                    : ''
                }`}
              </Col>
            </Row>
            <Row className="mb-15">
              <Col className="smallBoldFont" span={5}>
                出張PSG検査単価
              </Col>
              <Col className="standardFont" span={19}>
                {`￥ ${
                  data?.psg_unit_price || data?.psg_unit_price === 0
                    ? parseInt(data.psg_unit_price.toString()).toLocaleString()
                    : ''
                }`}
              </Col>
            </Row>
            <Row className="mb-15">
              <Col className="smallBoldFont" span={5}>
                簡易PSG検査単価
              </Col>
              <Col className="standardFont" span={19}>
                {`￥ ${
                  data?.simplicity_unit_price || data?.simplicity_unit_price === 0
                    ? parseInt(data.simplicity_unit_price.toString()).toLocaleString()
                    : ''
                }`}
              </Col>
            </Row>
            <Row className="mb-15">
              <Col className="smallBoldFont" span={5}>
                請求可能未受診月数
              </Col>
              <Col className="standardFont" span={19}>
                {data?.billable_month}ヶ月
              </Col>
            </Row>
            <Row className="mb-15">
              <Col className="smallBoldFont" span={5}>
                入金名
              </Col>
              <Col className="standardFont" span={19}>
                {data?.account_name}
              </Col>
            </Row>
            <Row className="mb-15">
              <Col className="smallBoldFont" span={5}>
                入金リスト振込備考
              </Col>
              <Col className="standardFont" span={19}>
                {data?.remark_for_remittance}
              </Col>
            </Row>
            <Row className="mb-15">
              <Col className="smallBoldFont" span={5}>
                営業担当
              </Col>
              <Col className="standardFont" span={19}>
                {data?.in_charge_of_sales}
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </Wrap>
  );
};
export default MedicalInstitutionDetail;
